import create from 'zustand'
export const useStore = create(() => ({ partnerLogo: "" }))